
export default {
  name: 'DialogPrivacyNotice',
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      display: false,
      urlFile: '',
    }
  },
  watch: {
    show(val) {
      if (val === true) {
        this.display = true
        this.urlFile = '/files/Privacy Policy (for Customer and clients).pdf'
      } else {
        this.urlFile = ''
        this.display = false
      }
    },
  },
}
